// extracted by mini-css-extract-plugin
export default {"root":"UwKSn4ArJH43DUtI8DcQ","placeHolderShimmer":"jIC8tGU8nqPo2UDRprXw"};